module.exports = __webpack_public_path__ + "img/github.fff79394.svg";